import React from 'react';
import { Bar } from 'react-chartjs-2';
const plugins = [
  {
    id: 'mouseLine',

    afterEvent: function (chart, e) {
      var chartArea = chart.chartArea;
      if (
        e.x >= chartArea.left &&
        e.y >= chartArea.top &&
        e.x <= chartArea.right &&
        e.y <= chartArea.bottom &&
        chart.active.length
      ) {
        chart.options.mouseLine.x = chart.active[0]._model.x;
      } else {
        chart.options.mouseLine.x = NaN;
      }
    },
    beforeDraw: function () {},

    afterDraw: function (chart) {
      var ctx = chart.chart.ctx;
      var chartArea = chart.chartArea;
      var x = chart.options.mouseLine.x;

      if (!isNaN(x)) {
        ctx.save();
        ctx.strokeStyle = chart.options.mouseLine.color;
        ctx.lineWidth = 1;
        ctx.moveTo(chart.options.mouseLine.x, chartArea.bottom);
        ctx.lineTo(chart.options.mouseLine.x, chartArea.top);
        ctx.stroke();
        ctx.restore();
      }
    },
  },
];
const OIModalBars = ({
  styles2,
  isMobile,
  chartdata,
  chartOptions,
  barData,
  barOptionsOI,
  barDataOI,
  barOptionsOITwo,
}) => {
  return (
    <div>
      <div
        style={
          isMobile
            ? styles2.boardModalBigGraphMobile
            : styles2.boardModalBigGraph
        }
      >
        <Bar
          height={isMobile ? 200 : 100}
          data={chartdata}
          options={chartOptions}
          plugins={plugins}
        />
      </div>
      <div
        style={
          isMobile
            ? styles2.boardModalSmallGraphOIMobile
            : {
                ...styles2.boardModalSmallGraph,
                width: 'calc(96% - 30px)',
                marginLeft: '3%',
              }
        }
      >
        <Bar data={barData} options={barOptionsOI} />
      </div>
      <div
        style={
          isMobile
            ? styles2.boardModalSmallGraphOITwoMobile
            : {
                ...styles2.boardModalSmallGraphtwo,
                width: 'calc(96% - 30px)',
                marginLeft: '3%',
              }
        }
      >
        <Bar data={barDataOI} options={barOptionsOITwo} />
      </div>
    </div>
  );
};
export default OIModalBars;



// WEBPACK FOOTER //
// ./src/components/Modals/OI Modal/components/OIModalBars.jsx